<template>
  <ui-dialog
    :show="show"
    @input="closeDialog"
    :title="
      editMode
        ? $t('message.permissions.editAccountType')
        : $t('message.permissions.addUserToTeam')
    "
  >
    <PreviewData :show-email="editMode" />
    <v-form v-model="valid">
      <v-radio-group v-model="accountType" row>
        <v-radio :value="accountTypes.MANAGER">
          <template #label>
            <span class="mr-2">{{
              $t(`message.permissions.accountTypes.${accountTypes.MANAGER}`)
            }}</span>
            <TooltipIcon color="accent" icon="mdi-information" :icon-size="22">
              {{ $t("message.permissions.managerTooltip") }}
            </TooltipIcon>
          </template>
        </v-radio>
        <v-radio :value="accountTypes.ADMIN">
          <template #label>
            <span class="mr-2">{{
              $t(`message.permissions.accountTypes.${accountTypes.ADMIN}`)
            }}</span>
            <TooltipIcon color="accent" icon="mdi-information" :icon-size="22">
              {{ $t("message.permissions.adminTooltip") }}
            </TooltipIcon>
          </template>
        </v-radio>
      </v-radio-group>

      <v-text-field
        v-if="!editMode"
        v-model="email"
        color="primary"
        :label="$t('message.permissions.emailAddress')"
        v-validate="'required|email'"
        :error-messages="errors.collect(emailLabel)"
        :data-vv-name="emailLabel"
      ></v-text-field>
    </v-form>

    <SectionLoader :status="loading" :opacity="1" />

    <template #actions>
      <ui-button @click="showPermissionsDialog" v-if="editMode && isManager">
        {{ $t("message.permissions.backToPermissions") }}
      </ui-button>

      <ui-button color="primary" @click="submit" class="ml-auto">
        {{ submitBtnLabel }}
      </ui-button>
    </template>
  </ui-dialog>
</template>

<script>
import TooltipIcon from "@/components/ui/TooltipIcon";
import PreviewData from "@/components/Permissions/PreviewData";
import SectionLoader from "@/components/Loader/SectionLoader";

import { PermissionsActiveDialog } from "@/enums/permissions-active-dialog";
import { companyMember } from "@/helpers/mixins/company-member";
import { GTM_EVENT_NAME } from "@/enums/gtm-events";

export default {
  name: "MemberDialog",
  mixins: [companyMember],
  components: {
    TooltipIcon,
    PreviewData,
    SectionLoader
  },
  props: {
    show: {
      type: Boolean,
      default: true
    },
    loading: Boolean
  },
  data() {
    return {
      valid: false,
      emailLabel: this.$t("message.common.email").toLowerCase()
    };
  },
  computed: {
    submitBtnLabel() {
      if (this.isManager) {
        return this.$t("message.common.next");
      } else {
        if (this.editMode) {
          return this.$t("message.common.save");
        }
        return this.$t("message.permissions.addUser");
      }
    }
  },
  methods: {
    async submit() {
      const isValid = await this.$validator.validate();
      if (isValid) {
        if (this.isAdmin) {
          this.$gtm.trackCustomEvent({
            event: GTM_EVENT_NAME.PERMISSIONS_USER_ADD_FULL_ACCESS
          });

          this.setActiveDialog(PermissionsActiveDialog.COMPLETE);
        } else {
          this.setActiveDialog(PermissionsActiveDialog.FACILITIES);
        }
      }
    },

    showPermissionsDialog() {
      this.setActiveDialog(
        PermissionsActiveDialog.PERMISSIONS,
        this.isAdmin ? "preview" : this.mode
      );
    }
  }
};
</script>
